import styles from "./FormSubmitButton.module.css";
import { Button, ButtonColor } from '@ctouch-europe-b-v/react-component-library';

const FormSubmitButton = ({onClick, className}) => {
  return <Button className={[styles.button, className].filter(e => !!e).join(" ")} onClick={onClick} title="CONTINUE" variant={ButtonColor.blue} iconName={"arrow-right"}/>
}

export default FormSubmitButton;